import { RootState } from "../store";

export const selectTaxConditions = (state: RootState) => state.taxConditions.taxConditions;
export const selectErrorMessageTaxConditions = (state: RootState) => state.taxConditions.errorMessage;